module.exports = __webpack_public_path__ + "img/maximize.21a50e4a.png";